import { MoreOutlined } from '@ant-design/icons'
import React from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import { DropdownMenu } from 'sutra/components'

type Props = {
  url: string
  title: string
}

/**
 * Row-trailing actions kebab for a source's listing URL: open it in a new
 * tab, or copy it to the clipboard. Both stop propagation so they never also
 * trigger the row's own click-to-navigate handler.
 */
export const SourceUrlKebab: React.FC<Props> = ({ url, title }) => (
  <DropdownMenu
    nativeButton={false}
    items={[
      {
        key: 'view-url',
        label: 'View URL',
        onClick: (event) => {
          event.stopPropagation()
          window.open(url, '_blank', 'noopener,noreferrer')
        },
      },
      {
        key: 'copy-url',
        label: 'Copy URL',
        onClick: (event) => {
          event.stopPropagation()
          navigator.clipboard
            .writeText(url)
            .then(() => toast.info('URL copied to clipboard'))
        },
      },
    ]}
  >
    <ActionIcon
      aria-label={`Actions for ${title}`}
      onClick={(event) => {
        event.stopPropagation()
        event.preventDefault()
      }}
    />
  </DropdownMenu>
)

const ActionIcon = styled(MoreOutlined)`
  font-size: 18px;
  cursor: pointer;
`
